import moment from 'moment';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import infoIcon from '../../assets/icons/icon_info.svg';
import { Spacer } from '../../common/components/Spacer';
import {
  CurrentTimeText,
  CurrentTimeTextLayout,
  SectionContentContainer,
  SectionHeading,
} from '../../common/components/styledComponents';
import { WindowSizeContext, WindowSize } from '../../hooks/windowSizeHook';

import { MobileRequestStatusDescriptionModal } from './MobileRequestStatusDescriptionModal';
import { PaymentTable } from './PaymentTable';
import { StatusDiagram } from './StatusDiagram';

const HeadingWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  gap: 5px;
`;
const InfoButton = styled.span`
  background-image: url(${infoIcon});
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 24px;
  height: 24px;
  color: #a3a6ab;
`;

export const Payments: React.FC = () => {
  const { t: globalT } = useTranslation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.payments',
  });
  const windowSize = useContext(WindowSizeContext);
  const isMobile = windowSize === WindowSize.MOBILE;

  const currentTime = moment().format(`${globalT('currentTime')}`);

  const [open, setOpen] = useState(false);

  return (
    <SectionContentContainer>
      {isMobile ? (
        <HeadingWrapper>
          <SectionHeading>{t('title')}</SectionHeading>
          <InfoButton onClick={() => setOpen(true)} />
        </HeadingWrapper>
      ) : (
        <SectionHeading>{t('title')}</SectionHeading>
      )}
      <CurrentTimeTextLayout
        right={<CurrentTimeText>{currentTime}</CurrentTimeText>}
      />
      <PaymentTable />
      {!isMobile && (
        <>
          <Spacer height="70px" />
          <StatusDiagram />
        </>
      )}
      {isMobile && (
        <MobileRequestStatusDescriptionModal
          open={open}
          onClose={() => setOpen(false)}
        />
      )}
    </SectionContentContainer>
  );
};
